export const newQuery = 'NQ';

export enum AndOrOperand {
    and = 'AND',
    or = 'OR'
}

export enum QueryOperator {
    is = '=',
    isNot = '!=',
    contains = 'LIKE',
    startWith = 'STARTSWITH',
    endWith = 'ENDSWITH',
    isEmpty = 'ISEMPTY',
    isNotEmpty = 'ISNOTEMPTY',
    before = '<',
    after = '>',
    notContain = 'NOT LIKE',
    greaterThan = '>=',
    lessThan = '<=',
    anything = 'ANYTHING',
    between = 'BETWEEN'
}

export enum SecondaryOperator {
    betweenOp = '@'
}

export type AllOperators = QueryOperator | SecondaryOperator | AndOrOperand | typeof newQuery;

export enum QueryExpressionType {
    constant = 'Constant', // "value" field
    unary = 'Unary', // operands.length === operands.length === 1
    nary = 'Nary', // operands.length - 1 === operators.length
    field = 'Field' // "value" field
}

export interface IOperator {
    label: string;
    value: QueryOperator;
    hasValue: boolean; // false = unary, no value
    operator?: SecondaryOperator; // exists if operator takes 2 values, ie: BETWEEN
}

export const supportedOperators: IOperator[] = [
    {
        label: 'is',
        value: QueryOperator.is,
        hasValue: true
    },
    {
        label: 'isnot',
        value: QueryOperator.isNot,
        hasValue: true
    },
    {
        label: 'contains',
        value: QueryOperator.contains,
        hasValue: true
    },
    {
        label: 'starts with',
        value: QueryOperator.startWith,
        hasValue: true
    },
    {
        label: 'ends with',
        value: QueryOperator.endWith,
        hasValue: true
    },
    {
        label: 'is empty',
        value: QueryOperator.isEmpty,
        hasValue: false
    },
    {
        label: 'is not empty',
        value: QueryOperator.isNotEmpty,
        hasValue: false
    },
    {
        label: 'before',
        value: QueryOperator.before,
        hasValue: true
    },
    {
        label: 'after',
        value: QueryOperator.after,
        hasValue: true
    },
    {
        label: 'does not contain',
        value: QueryOperator.notContain,
        hasValue: true
    },
    {
        label: 'greater than',
        value: QueryOperator.greaterThan,
        hasValue: true
    },
    {
        label: 'less than',
        value: QueryOperator.lessThan,
        hasValue: true
    },
    {
        label: 'is anything',
        value: QueryOperator.anything,
        hasValue: false
    },
    {
        label: 'between',
        value: QueryOperator.between,
        hasValue: true,
        operator: SecondaryOperator.betweenOp
    }
];
export const allOperatorsMap: Map<string, IOperator> = new Map();
supportedOperators.forEach((operator) => {
    allOperatorsMap.set(operator.value, operator);
});

// used for table row
export interface IAndOrTableRow {
    andOr?: AndOrOperand; // relationship to previous row, NQ doesn't have andOr
    selected?: AndOrOperand; // releationship to next row, reverse of andOr
    column?: string;
    operator?: QueryOperator;
    value?: string;
    additionalValue?: string; // for operator like BETWEEN, which requries 2 values
    group: {
        id: number;
    };
}

// actual condition expression in payload
export interface IConditionExpression {
    type: QueryExpressionType;
    value?: string; // mutually exclusive with operators & operands
    operators?: AllOperators[]; // mutually exclusive with value
    operands?: IConditionExpression[]; // mutually exclusive with value
}
